module.exports = __webpack_public_path__ + "img/02.0d9f8ba0.png";